// extracted by mini-css-extract-plugin
export var container = "recipe-simple-header-module--container--a7df2";
export var link = "recipe-simple-header-module--link--cdb1c";
export var title = "recipe-simple-header-module--title--89303";